
import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useBotDeploymentValidation } from '@/hooks/use-bot-deployment-validation';
import { useTranslation } from 'react-i18next';

interface PageHeaderProps {
  onOpenDeployDialog: () => void;
}

export const PageHeader = ({
  onOpenDeployDialog
}: PageHeaderProps) => {
  const {
    canDeployBot,
    getDeploymentErrorMessage,
    currentCount,
    maxBots
  } = useBotDeploymentValidation();

  const { t } = useTranslation();

  const errorMessage = getDeploymentErrorMessage();

  const deployButton = (
    <Button className="bg-primary hover:bg-primary/90" onClick={onOpenDeployDialog} disabled={!canDeployBot()}>
      <Plus size={16} className="mr-2" />
      {t('deploy_new_bot_with_count', { currentCount, maxBots })}
    </Button>
  );

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div>
        <h1 className="text-3xl font-bold">{t('my_bots_title')}</h1>
        <p className="text-muted-foreground mt-1">{t('my_bots_subtitle')}</p>
      </div>
      {errorMessage ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              {deployButton}
            </TooltipTrigger>
            <TooltipContent className="max-w-[300px]">
              <p>{errorMessage}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : deployButton}
    </div>
  );
};
